import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace',
    standalone: false
})
export class ReplacePipe implements PipeTransform {

  transform(value: string, regexValue: string, replaceValue: string, flag?: boolean): any {
    let regex = new RegExp(regexValue, 'g');
    if(value){
      if(flag){
        return value.replace(regex, m => (m === ',' ? '.' : ',') );
      } else {
        return value.replace(regex, replaceValue);
      }
    }else{
      return value;
    }
    
  }

}
